'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import { DEFAULT_MAX_SUMMARY_LENGTH } from './constants.js';

var apiGetResume = function (accessToken, langCode, url) {
    if (accessToken === void 0) { accessToken = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, responseJson, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseJson = _a.sent();
                    if (responseJson) {
                        return [2 /*return*/, responseJson];
                    }
                    return [2 /*return*/, {}];
                case 3:
                    e_1 = _a.sent();
                    console.error('apiGetResume ', e_1);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var apiDoUpload = function (accessToken, langCode, url, file, resumeId, isReplace) {
    if (accessToken === void 0) { accessToken = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    formData = new FormData();
                    formData.append('resume_file', file);
                    if (resumeId && isReplace) {
                        formData.append('resume_id', resumeId.toString());
                        // When resumeId is provided it always replaced
                        formData.append('is_replaced', 'true');
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept-Language': langCode
                            },
                            body: formData
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_2 = _a.sent();
                    console.log('apiDoUpload ', e_2);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var apiPostResume = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, url, data, body, response, ex_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                accessToken = params.accessToken, url = params.url, data = params.data;
                body = {
                    jobTitle: data.jobTitle,
                    yearsExperience: data.yearsExperience,
                    locations: data.locations,
                    jobLevelId: data.jobLevelId,
                    highestDegreeId: data.highestDegreeId,
                    salary: data.salary,
                    companyIndustries: data.companyIndustries,
                    industries: data.industries,
                    resumeId: data.resumeId,
                    jobFunction: data.jobFunction
                };
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify(body)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                ex_1 = _a.sent();
                console.log(ex_1);
                return [2 /*return*/, {
                        meta: {
                            message: '',
                            code: 400
                        }
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateUserContactInfo = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, url, data, postData, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                accessToken = params.accessToken, url = params.url, data = params.data;
                postData = __assign(__assign({}, data), { isSearchable: data.isSearchable ? 1 : 0 });
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify(postData)
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                _a.sent();
                return [2 /*return*/, {
                        meta: {
                            message: '',
                            code: 400
                        }
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
var getJobLevelList = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'GET'
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var autoCompleteJobTitle = function (url, keyword, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer ".concat(accessToken)
                    },
                    body: JSON.stringify({
                        keyword: keyword
                    })
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getUserContactInfo = function (accessToken, langCode, url) {
    if (accessToken === void 0) { accessToken = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: {
                                Authorization: "Bearer ".concat(accessToken),
                                Accept: 'application/json',
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_3 = _a.sent();
                    console.log('getUserContactInfo ', e_3);
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var formatSummary = function (summary) {
    var formattedSummary = summary;
    if (formattedSummary.length > DEFAULT_MAX_SUMMARY_LENGTH) {
        formattedSummary = summary.slice(0, DEFAULT_MAX_SUMMARY_LENGTH);
    }
    return formattedSummary;
};
var updateSummaryProfileSetting = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, accessToken, _a, summary, API_URL, response, ex_3;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                url = params.url, accessToken = params.accessToken, _a = params.summary, summary = _a === void 0 ? '' : _a;
                API_URL = "".concat(url, "/api-gateway/v1.0/profile/cookie");
                return [4 /*yield*/, fetch(API_URL, {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            summary: formatSummary(summary)
                        })
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                ex_3 = _b.sent();
                console.error(ex_3);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { apiDoUpload, apiGetResume, apiPostResume, autoCompleteJobTitle, formatSummary, getJobLevelList, getUserContactInfo, updateSummaryProfileSetting, updateUserContactInfo };
//# sourceMappingURL=apiServices.js.map
